import React from 'react';

const IEWarning = () => (
  <div className="orders">
    <div className="order__helper order__helper-IEtext">
      Purchase history is not currently available on Internet Explorer browser.
      <br />{' '}
      <a href="https://www.google.com/chrome" target="_blank">
        Download Chrome
      </a>{' '}
      or try another browser.
    </div>
  </div>
);

export default IEWarning;
